import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconChevronTop"><Path fillRule="evenodd" clipRule="evenodd" d="M12.8839 8.94448C12.3957 8.45633 11.6043 8.45633 11.1161 8.94449L4.53033 15.5303C4.23744 15.8232 3.76256 15.8232 3.46967 15.5303C3.17678 15.2374 3.17678 14.7625 3.46967 14.4696L10.0554 7.88383C11.1294 6.80989 12.8706 6.80988 13.9445 7.88382L20.5303 14.4696C20.8232 14.7625 20.8232 15.2374 20.5303 15.5303C20.2374 15.8232 19.7626 15.8232 19.4697 15.5303L12.8839 8.94448Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTop;
